// sitemap-gen-v3
const _SITEMAP_BUILD_VERSION = "v8-publish-register";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale dynamic import chunks after a new deploy.
const RELOAD_KEY = "lov:chunk-reloaded";
const isChunkLoadError = (msg: string) =>
  /dynamically imported module|Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError/i.test(msg);

window.addEventListener("error", (e) => {
  if (e?.message && isChunkLoadError(e.message) && !sessionStorage.getItem(RELOAD_KEY)) {
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = String(e?.reason?.message || e?.reason || "");
  if (isChunkLoadError(msg) && !sessionStorage.getItem(RELOAD_KEY)) {
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  }
});
// Clear the guard once the app successfully boots.
setTimeout(() => sessionStorage.removeItem(RELOAD_KEY), 5000);

createRoot(document.getElementById("root")!).render(<App />);
